/**
 * @generated SignedSource<<4cd14185e076273155e248d3f5b80544>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ModifyAutopilotForEventMovementTypeEnum = "Day" | "None" | "Week" | "%future added value";
export type BatchModifyAutopilotForEventsMutationInput = {
  clientMutationId?: string | null;
  events?: ReadonlyArray<AutopilotEventToModify> | null;
  orgRelayId: string;
};
export type AutopilotEventToModify = {
  externalEventId: string;
  movementType: ModifyAutopilotForEventMovementTypeEnum;
};
export type ModifyAutopilotForEventsBatchMutation$variables = {
  input: BatchModifyAutopilotForEventsMutationInput;
};
export type ModifyAutopilotForEventsBatchMutation$data = {
  readonly batchModifyAutopilotForEvents: {
    readonly clientMutationId: string | null;
  } | null;
};
export type ModifyAutopilotForEventsBatchMutation = {
  variables: ModifyAutopilotForEventsBatchMutation$variables;
  response: ModifyAutopilotForEventsBatchMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BatchModifyAutopilotForEventsMutationPayload",
    "kind": "LinkedField",
    "name": "batchModifyAutopilotForEvents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ModifyAutopilotForEventsBatchMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ModifyAutopilotForEventsBatchMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3204255931a03f162cb39d77f767db13",
    "id": null,
    "metadata": {},
    "name": "ModifyAutopilotForEventsBatchMutation",
    "operationKind": "mutation",
    "text": "mutation ModifyAutopilotForEventsBatchMutation(\n  $input: BatchModifyAutopilotForEventsMutationInput!\n) {\n  batchModifyAutopilotForEvents(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b628eda540141514c51babe9b0c01bb";

export default node;
